import RequestUtils from "utils/RequestUtils";
import NotelClassRes from "types/res/notelClass/NotelClassRes";
import CreateNotelClassReq from "types/req/notelClass/CreateNotelClassReq";
import UpdateNotelClassReq from "types/req/notelClass/UpdateNotelClassReq";
import DeleteNotelClassReq from "types/req/notelClass/DeleteNotelClassReq";

export default class NotelClassApi {
  private constructor() {}

  static async findAll(companyId: number) {
    return await RequestUtils.getArray(
      NotelClassRes,
      `/notelClass/findAll/${companyId}`
    );
  }

  static async create(companyId: number, data: CreateNotelClassReq) {
    return await RequestUtils.post(
      NotelClassRes,
      `/notelClass/create/${companyId}`,
      data
    );
  }

  static async update(
    companyId: number,
    data: UpdateNotelClassReq
  ): Promise<NotelClassRes> {
    return await RequestUtils.post(
      NotelClassRes,
      `/notelClass/update/${companyId}`,
      data
    );
  }

  static async delete(companyId: number, data: DeleteNotelClassReq) {
    return await RequestUtils.postVoid(`/notelClass/delete/${companyId}`, data);
  }
}
